import { CoreAppState } from '../state/core-app.state';
import { BaseResourceService } from './base-resource.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ActionLog } from '@prisma/client';
import { ActionLogResourceTypeMappings } from '@aa/nest/resource';
import { actionLogCompositeKeyOrder } from '@aa/nest/resource/objects';

@Injectable()
export class ActionLogService extends BaseResourceService<ActionLogResourceTypeMappings> {
  constructor(
    protected override readonly http: HttpClient,
    protected override readonly store: Store<CoreAppState>,
  ) {
    super(http, store, 'action-logs');
  }
}
